var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "450",
        "content-class": "dialog-plan-obiettivo",
        "retain-focus": false,
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "navy dialog-plan-obiettivo-card" },
        [
          _c(
            "div",
            {
              staticClass:
                "secondary white--text d-flex align-center font-hemi-head pa-4",
            },
            [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _vm._v("Aggiungi obiettivo slot"),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { depressed: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.dismiss()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text--text text--lighten-2 pa-2" }, [
            _vm._v(
              '\n      Seleziona uno o più svincolati da tenere come obiettivi per questo slot.\n      Un calciatore "obiettivo" é un calciatore che vorresti acquistare in questo slot\n    '
            ),
          ]),
          _vm._v(" "),
          _c("asta-svincolati", {
            key: _vm.pickerKey,
            staticClass: "dialog-plan-obiettivo-svincolati",
            attrs: {
              selected: _vm.addObiettivo,
              ruoliAllowed: [_vm.ruolo_id],
              dialogParent: _vm.dialog,
              showInformazioni: false,
              showStats: true,
              smallCalciatori: true,
              showButtonScartati: false,
              visuallyDisabledCalciatoriIds: _vm.obiettiviIds,
              pickerMode: "",
              forceClassic: "",
              ripple: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }